module.exports = __webpack_public_path__ + "static/eleven-sus-city-goals.45479b29.webp";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/assets/2022/photos/a-propos/sdgs/eleven-sus-city-goals.webp
// module id = 924
// module chunks = 3